import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./.././../../assets/css/add-new-question.css";
import { Redirect } from 'react-router';
import Header from "./../../Header";
import Menu from "./../../Menu";
import {SURGEON} from './../../../services/Surgeon';
import { CONFIG, URLS ,encryptPHI,decryptPHI} from "./../../../helpers/Common";

class PatientResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_additional_info: "",
      prevStep: 5,
      profileData: new Array(),
      redirect: false,
      redirectLisint:false,
      //patientAdditionalInfo:''
    };
    this.handleAction = this.handleAction.bind(this);
    this.setAddionalInfo = this.setAddionalInfo.bind(this);


  }

  componentWillMount() {
    this.setState({
      profileData: this.props.getProfileData,
      patient_additional_info:this.props.getPatientAdditionalInfo
    });
    
  }
  handleAction = e => {
    let profileData = this.state.profileData;
    profileData.patient_additional_info = this.state.patient_additional_info;

    var encryptedpatientProfile = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(profileData));

    localStorage.setItem('patientProfile', encryptedpatientProfile);
    
    var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem('data'));

    let data = JSON.parse(decryptedData);
    let complainData = this.props.getComplainData.complainTypeDetails;
    
    var decryptedallComplains = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("allComplains"));
    let all_complains = JSON.parse(decryptedallComplains);
    let newData = JSON.parse(localStorage.getItem("newData"));

    let saveData = new Array();
    let complainLocationData = this.props.getComplainLocationData;
    
    var encrypt_additional_info = encryptPHI(CONFIG.ENCRYPTION_KEY,this.state.patient_additional_info);
    var title = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.title);
    var first_name = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.first_name);
    var last_name = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.last_name);
    var email = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.email);
    var phone = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.phone);
    var gender = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.gender);
    var dob = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.dob);

    saveData = {
      patient_additional_info: encrypt_additional_info,
      answers:data,
      narrative_summary: profileData.narrative_summary,
      patient_id:this.props.getPatientId,
      all_complaints:all_complains,
      newData:newData,
      title: title,
      first_name: first_name,
      last_name: last_name,
      email: email,
      phone: phone,
      gender: gender,
      surgeon_id: this.props.surgeon_id,
      dob: dob,
    };
    if(this.props.isModify==true)
    {
      var encryptednarrative_summary = encryptPHI(CONFIG.ENCRYPTION_KEY,profileData.narrative_summary);
    
      for (let index = 0; index < all_complains.length; index++) 
      {
        all_complains[index].profileSummary = encryptPHI(CONFIG.ENCRYPTION_KEY,all_complains[index].profileSummary);
      }
      saveData['all_complaints'] = all_complains;
      saveData['narrative_summary'] = encryptednarrative_summary;
      saveData['narrative_id'] = this.props.getNarrativeId;
      this.props.setIsLoading(true);
      // console.log('Narative updated here ',saveData)
      SURGEON.updatePatientNarrative(JSON.stringify(saveData)).then(res => {
        if(res.data.header.error==0)
        {
          this.props.setIsLoading(false);
          localStorage.removeItem('data');
          localStorage.removeItem('patientProfile');
          this.setState({redirectLisint: true});
        }
        else
        {
          this.props.setIsLoading(false);
          alert('There was an error in update narrative')
          this.setState({redirectLisint: true});
        }

      }).catch(err => {
        this.props.setIsLoading(false);
        alert("There was an error in server response");
          this.setState({redirectLisint: true});
      });
    }
    else
    {
      // console.log('hits else condition')
    var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(saveData));
    localStorage.setItem("data",encryptedData); 
    
    var encryptedAllComplains = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(this.props.getAllComplains));
    localStorage.setItem("allComplains",encryptedAllComplains);
    
    this.setState({
        redirect:true
      })
    }

  };

  setAddionalInfo = e => {
    this.setState({
      patient_additional_info: e.target.value
    });
  };

  
  render() {
    if (this.state.redirect) {
      let path = "/surgeon/complain/thankyou/"+this.props.getPatientId;
      return <Redirect push to={path} />;
    }
    if (this.state.redirectLisint) {
      let path = "/surgeon/patients";
      return <Redirect push to={path} />;
    }
    return (
      <React.Fragment>
        <Header
          title="Patient Narrative Response"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="sec--question add-new-question">
          <form>
            <div className="question-form">
              <div className="container">
                <div className="row">
                  <div className="col-md-1 col-sm-1" />
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="txt">Add Any Additional Info</label>
                      <textarea
                        id="txt"
                        className="form-control"
                        onChange={this.setAddionalInfo}
                        value={this.state.patient_additional_info}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <div className="sec-btn patient--btn">
        
          <Link to="#" className="btn-img" onClick={this.handleAction}>
            <img
              src={require("./.././../../assets/img/icons/ic-complete-native.png")}
              alt=""
            />
            <span>Save</span>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default PatientResponse;
